import { initCarousel, initCarouselActions, resetCarousel } from "../../../js/components/carousel";

const reportCarousel = document.querySelectorAll('.newdev-reports__items');

export const newdevNews = () => {
  reportCarousel.forEach((carousel) => {
    initCarousel(carousel, true);
    initCarouselActions(carousel);
  });

  window.addEventListener('resize', () => {
    resetCarousel(reportCarousel);
  });
}



// WEBPACK FOOTER //
// ./src/templates/components/newdev-news/newdev-news.js